import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import deburr from 'lodash.deburr';
import { withStyles, Paper, MenuItem } from '@material-ui/core';
import { FHETextField } from '.';

class FHEWeatherAutoComplete extends PureComponent {
    static propTypes = {
        disabled: PropTypes.bool,
        baseValue: PropTypes.string,
        query: PropTypes.string.isRequired,
        classes: PropTypes.object.isRequired,
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        selectMeteo: PropTypes.func.isRequired,
        error: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
    };

    static defaultProps = {
        disabled: false,
        error: null,
        baseValue: null
    };

    constructor(props) {
        super(props);
        this.state = {
            suggestionsList: [],
            value: null,
            selectedValue: false
        };
    }

    onMouseDown = selection => {
        const { selectMeteo, name } = this.props;
        this.setState({
            value: selection,
            suggestionsList: [],
            selectedValue: true
        });

        selectMeteo(name, selection);
    };

    onBlur = e => {
        const { selectedValue } = this.state;
        e.preventDefault();
        this.setState({
            suggestionsList: []
        });
        if (selectedValue === false) {
            this.resetValue();
        }
    };

    resetValue = () => {
        const { baseValue } = this.props;
        this.setState({
            value: baseValue,
            selectedValue: false
        });
    };

    handleChange = event => {
        this.setState({
            value: event.target.value,
            selectedValue: false
        });

        if (event.target.value.length >= 3) {
            this.loadSuggestions(event.target.value);
        } else {
            this.setState({
                suggestionsList: []
            });
        }
    };

    getJson = yourUrl => {
        fetch(yourUrl)
            .then(response => response.json())
            .then(jsonData => {
                let suggestionsArray = [];
                if (jsonData.search_api.result) {
                    jsonData.search_api.result.map(result => {
                        suggestionsArray.push({
                            label: `${result.areaName[0].value}, ${result.region[0].value}, ${result.country[0].value}`,
                            link: true
                        });
                    });
                    this.setState({
                        suggestionsList: suggestionsArray
                    });
                }
            })
            .catch(error => {
                let suggestionsArray = [];
                suggestionsArray.push({
                    label: Translator.translate('general.noResults'),
                    link: false
                });
                this.setState({
                    suggestionsList: suggestionsArray
                });
            });
    };

    loadSuggestions = (value, { showEmpty = false } = {}) => {
        const { query } = this.props;
        const inputValue = deburr(value.toLowerCase());
        const inputLength = inputValue.length;

        if (inputLength >= 3 && !showEmpty) {
            this.getJson(query + inputValue);
        }
    };

    render() {
        const { suggestionsList, value } = this.state;
        const { disabled, error, label, baseValue, id, name, classes } = this.props;

        let newValue;
        if (value !== null) {
            newValue = value;
        } else {
            newValue = baseValue;
        }

        return (
            <div className={classes.autocompleteContainer}>
                <FHETextField
                    autoComplete="off"
                    id={id}
                    name={name}
                    disabled={disabled}
                    value={newValue}
                    error={error}
                    label={label}
                    onChange={this.handleChange}
                    onBlur={this.onBlur}
                />
                <div className={classes.suggestionsContainer}>
                    {suggestionsList.length > 0 ? (
                        <Paper square elevation={1}>
                            {suggestionsList.map((suggestion, index) => {
                                return (
                                    <MenuItem
                                        disabled={!suggestion.link}
                                        key={suggestion.label + index}
                                        component="div"
                                        onMouseDown={suggestion.link ? this.onMouseDown.bind(this, suggestion.label) : null}
                                    >
                                        {suggestion.label}
                                    </MenuItem>
                                );
                            })}
                        </Paper>
                    ) : null}
                </div>
            </div>
        );
    }
}

const styles = theme => ({
    autocompleteContainer: {
        width: '100%'
    },
    suggestionsContainer: {
        width: '100%',
        position: 'absolute',
        zIndex: 20,
        maxHeight: 200,
        overflowY: 'scroll'
    }
});

export default withStyles(styles, { withTheme: true })(FHEWeatherAutoComplete);



// WEBPACK FOOTER //
// ./data/components/FHEWeatherAutoComplete.js